import { useEffect } from 'react'
//import useAuth from '../../../../hooks/useAuth'
import { useNavigate } from 'react-router-dom';
import {authUserSignal} from '../../../../signals/authSignal';
import { authService } from '../../../../App';

const Logout = () => {
    //const {setAuth} = useAuth();
    const navidate = useNavigate();

    useEffect(()=>{
        const doLogout = async () => {
            // Call backend logout endpoint to revoke token family
            await authService.logout();
            // Clear local auth state
            authUserSignal.value = undefined;
            navidate('/login', { replace: true });
        };
        doLogout();
    }, [navidate]);
  return (
    <div>Logout</div>
  )
}

export default Logout